import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[delayRender]'
})
export class DelayRenderDirective implements OnInit {
    /** Delay duration in milliseconds */
    @Input() public delayRender: number;
    private _hasEmbeddedView = false;

    constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef) {}

    public ngOnInit(): void {
        if (!this.delayRender) {
            this.delayRender = 0;
        }

        setTimeout(() => {
            if (!this._hasEmbeddedView) {
                this.viewContainer.createEmbeddedView(this.templateRef);
                this._hasEmbeddedView = true;
            }
        }, this.delayRender);
    }
}
